import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backroundColor: '#ffffff',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const SubmittedPhotoAlertDialog = withStyles((theme) => ({
    paper: {
      backgroundColor: '#ffffff',
    },
}))(Dialog);

const SubmittedPhotoAlertCloseButton = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.main,
    },
}))(Button);

const SubmittedCheckCircleIcon = withStyles((theme) => ({
  root: {
      color: theme.palette.primary.main,
      fontSize: '40px'
  },
}))(CheckCircleIcon);

const SubmittedPhotoAlert = ({submittedPhotoAlertOpen, submittedPhotoAlertClose}) => {
  return (
    <div>
      <SubmittedPhotoAlertDialog onClose={submittedPhotoAlertClose} aria-labelledby="customized-dialog-title" open={submittedPhotoAlertOpen}>
        <DialogTitle id="customized-dialog-title" onClose={submittedPhotoAlertClose}>
          Your Photo Has Been Submitted
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <SubmittedCheckCircleIcon outlined></SubmittedCheckCircleIcon>
            </div>
          </Typography>
          <Typography gutterBottom>
            ODNR will review the photo and if selected it will be added to the trail photos gallery.
          </Typography>
        </DialogContent>
        <DialogActions>
          <SubmittedPhotoAlertCloseButton autoFocus onClick={submittedPhotoAlertClose}>
            OK
          </SubmittedPhotoAlertCloseButton>
        </DialogActions>
      </SubmittedPhotoAlertDialog>
    </div>
  );
}

export default SubmittedPhotoAlert;